import { render, staticRenderFns } from "./PMPreview.vue?vue&type=template&id=5ad2a6a4"
import script from "./PMPreview.vue?vue&type=script&lang=js"
export * from "./PMPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports